<template>
  <footer class="footer">
    <div class="footer__box">
      <div class="footer__links">
        <a
          class="footer__link"
          href="http://vivid-leaf.com/index.php?page=imprint"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ $t('imprint') }}
        </a>
        <a
          class="footer__link"
          href="https://brodtmann-consulting.com/index.php?page=dataPrivacy"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ $t('privacyPolicy') }}
        </a>
      </div>
      <div class="footer__copyright">
        &copy; {{ new Date().getFullYear() }}
        <a href="http://vivid-leaf.com/" target="_blank"> &nbsp; VividLeaf </a>&nbsp;
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style></style>
